import React from 'react';

import Image from '../../../components/Image/Image.tsx';
import { IImageData } from '@pages/Root/services/api/interfaces.ts';
import PublisherLogo from '../PublisherLogo/PublisherLogo.tsx';
import { StorySize } from '../../types/story-types';

import './StorySmall.scss';

interface StorySmallProps {
  imageList?: IImageData[];
  category?: string;
  title: string;
  publisherLogo?: string;
  darkPublisherLogo?: string;
  publisherName?: string;
  hideImage: boolean;
  hidePublisher: boolean;
  hideCategory: boolean;
  className?: string;
}

const StorySmall: React.FC<StorySmallProps> = ({
  imageList,
  category,
  title,
  publisherLogo,
  publisherName,
  darkPublisherLogo,
  hideImage = false,
  hidePublisher = false,
  hideCategory = true,
  className = 'story-small',
}) => {
  let chosenClassName = className;
  if (hideImage) {
    chosenClassName += ' story-small-noimage';
  }

  return (
    <div className={chosenClassName}>
      {!hideImage && (
        <div className="small-story-image-container">
          <Image
            withSkeleton
            className="story-image-sm"
            imageContainerClassName="border-radius-sm"
            alt={title}
            imageList={imageList}
          />
        </div>
      )}
      <div className="story-body">
        {!hidePublisher && publisherLogo && (
          <PublisherLogo
            publisherLogo={publisherLogo}
            publisherName={publisherName ?? ''}
            storySize={StorySize.SMALL}
            darkPublisherLogo={darkPublisherLogo}
          />
        )}
        <h2 className="story-title title-sm">{title}</h2>
        {!hideCategory && category && (
          <span className="story-category">{category}</span>
        )}
      </div>
    </div>
  );
};

export default StorySmall;
